console.log('log from example-vendor.js')